// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-a7a","title":"styles_title__1yXo0"};